import sound from './draw.wav';export default sound;